import React from "react"
import Head from "next/head"
import { useRouter } from "next/router"

// components
import { Typography, Divider, Modal, Tabs, Card } from "antd"
import { RedEnvelopeFilled, ClockCircleFilled } from "@ant-design/icons"

// configs
import config from "config"

// layouts
import MainLayout from "layouts/Main"

// context
import { useAuth } from "store/auth"
import { useResto } from "store/resto"
import { useTranslation } from "react-i18next"
import { useOrders } from "store/orders"
import { useReservations } from "store/reservations"

// custom
import UserReservationList from "components/UserReservationList"
import UserOrderList from "components/UserOrderList"
import TabOnlineOrder from "components/TabOnlineOrder"
import TabReservations from "components/TabReservations"
import styled from "@emotion/styled"
import { useFunnel } from "store/funnel"

const Page = styled.div`
  // .ant-tabs-top > .ant-tabs-nav::before {
  // border-bottom: 1px solid ${(props) => props.barColor};
  // }

  @media (max-width: 768px) {
    .ant-card {
      margin: 0 -16px !important;
    }
  }
`

const Home = () => {
  const restoSettings = useResto()
  const orders = useOrders()
  const router = useRouter()

  const [tab, setTab] = React.useState("online-order")
  const [modal, contextHolder] = Modal.useModal()

  const funnel = useFunnel()

  const reservations = useReservations()
  const { t } = useTranslation()

  const { isAuthentificated } = useAuth()

  React.useEffect(() => {
    const hash = typeof window !== "undefined" ? window.location.hash : null
    const defaultTab =
      hash &&
      hash !== "" &&
      hash.replace("#", "") === "reservation" &&
      config.reservation
        ? "reservation"
        : "online-order"
    setTab(defaultTab)

    // remove hash from url
    if (hash) {
      window.history.replaceState(
        null,
        "",
        window.location.href.replace(hash, "")
      )
    }
  }, [])

  React.useEffect(() => {
    if (restoSettings && restoSettings.popup) {
      modal.info({
        title: restoSettings.popup_title || "Title",
        content: (
          <Typography.Paragraph style={{ whiteSpace: "break-spaces" }}>
            {restoSettings.popup_description || "No message"}
          </Typography.Paragraph>
        ),
        onOk() {},
      })
    }
  }, [modal, restoSettings])

  return (
    <Page barColor={config.textColor}>
      {contextHolder}

      <Head>
        <title>{`${config.title} - ${config.subtitle}`}</title>
      </Head>

      {isAuthentificated && orders.currentOrders.length > 0 && (
        <UserOrderList
          data={orders.currentOrders}
          onSelect={(orderId) => {
            router.push(`/order?id=${orderId}`)
          }}
        />
      )}
      {isAuthentificated && reservations.currentReservations.length > 0 && (
        <UserReservationList data={reservations.currentReservations} />
      )}

      {isAuthentificated &&
        (reservations.currentReservations.length > 0 ||
          orders.currentOrders.length > 0) && (
          <Divider
            style={{
              borderTopColor: "transparent",
            }}
          />
        )}

      <Card
        data-testid="app-container"
        style={{ minHeight: "400px", marginBottom: "20px" }}
      >
        <Tabs
          activeKey={tab}
          tabBarStyle={{
            color: config.textColor,
          }}
          onChange={(key) => {
            setTab(key)
            funnel.add(`tab_change_${key.replace("-", "_")}`)
          }}
          items={[
            {
              icon: <RedEnvelopeFilled />,
              label: <Typography.Text>{t("order")}</Typography.Text>,
              key: "online-order",
              children: <TabOnlineOrder />,
            },
            ...(config.reservation
              ? [
                  {
                    icon: <ClockCircleFilled />,
                    label: t("reserve_table"),
                    key: "reservation",
                    children: <TabReservations />,
                  },
                ]
              : []),
          ]}
        />
      </Card>
    </Page>
  )
}

Home.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>
}

export default Home
